module.exports = __webpack_public_path__ + "assets/img/life-2.d959b085.jpg";